jQuery(function ($) {
  $("button.tools-toggle").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();

    const target = $($(this).data("target"));

    if (target.length > 0) {
      if (target.hasClass("active")) {
        target.removeClass("active");
      } else {
        $(".tools-dropdown").removeClass("active");
        target.addClass("active");
      }
    }
  });

  $("button.tools-toggle").on("click", function (e) {
    e.stopPropagation();
  });

  $(document).on("click", function (e) {
    if (
      $(".tools-dropdown").hasClass("active") &&
      !$(e.target).closest(".tools-dropdown").length
    ) {
      $(".tools-dropdown").removeClass("active");
    }
  });

  // Language toggle # ///////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $("#select-site-language").on("change", function () {
    var selectedOption = this.value;
    if (selectedOption) {
      window.location.href = selectedOption;
    }
  });
  // Language toggle # ///////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Text scaling # ///////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  function setTextScale(size) {
    const sizes = [100, 150, 200];
    $(".toggle-ts").removeClass("active");
    sizes.forEach((item) => {
      $("html").removeClass(`ts${item}`);
    });
    $("html").addClass(`ts${size}`);
    $(`.toggle-ts[data-scale='${size}']`).addClass("active");
    $("#select-fontsize").val(size);

    localStorage.setItem("tema-text-scale", size);
  }

  const currentScale = localStorage.getItem("tema-text-scale") || 100;
  setTextScale(currentScale);

  $(".toggle-ts").on("click", function (e) {
    e.preventDefault();
    const elm = $(this);
    const newScale = elm.data("scale");

    setTextScale(newScale);
  });

  $("#select-fontsize").on("change", function (e) {
    const newScale = $(this).val();
    setTextScale(newScale);
  });
  // Text scaling # ///////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END
});
